/**
 * Cart page — BSS "stuck button" guard.
 *
 * (The $250 USD minimum-order rule — including the checkout lock while the
 * cart syncs and the click/submit guard — lives in assets/min-order.js, the
 * single owner of that rule for the cart page and the drawer.)
 *
 * BSS B2B gates the checkout button with an inline
 * `pointer-events:none;cursor:not-allowed` while it recalculates the cart,
 * and is supposed to restore it when done. On this store that restore never
 * fires, so the button stays permanently dead. If the button is still gated
 * after BSS's processing window, we restore interactivity ourselves.
 *
 * This never navigates to /checkout directly, and never strips BSS/QI
 * handlers — a real click still runs BSS's checkout flow and case-size (QI)
 * validation. A button that is `disabled` (empty cart, NOSALE item, below
 * minimum, cart syncing) is left non-interactive on purpose.
 */
(function () {
  var CHECKOUT_SELECTOR =
    '.cart__footer .cart__checkout-button, form[action*="/cart"] [name="checkout"]';
  var GRACE_MS = 2500; // let BSS keep the button gated this long before we step in
  var SCAN_MS = 400;
  var blockedSince = new WeakMap();

  function isGatedByPointerEvents(btn) {
    if (btn.disabled) return false; // legitimately disabled — leave it alone
    return window.getComputedStyle(btn).pointerEvents === 'none';
  }

  function scanStuck() {
    var buttons = document.querySelectorAll(CHECKOUT_SELECTOR);
    var now = Date.now();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!isGatedByPointerEvents(btn)) {
        blockedSince.delete(btn);
        continue;
      }
      var since = blockedSince.get(btn);
      if (since == null) {
        blockedSince.set(btn, now);
        continue;
      }
      if (now - since >= GRACE_MS) {
        btn.style.pointerEvents = 'auto';
        btn.style.cursor = 'pointer';
        blockedSince.delete(btn);
      }
    }
  }

  function start() {
    scanStuck();
    setInterval(scanStuck, SCAN_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
